export default __webpack_public_path__ + "static/media/ASSETS_page-1.80bd97b5.png";